import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import './Billing.css';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotate, faMoneyBill, faBuildingColumns, faBackward } from '@fortawesome/free-solid-svg-icons';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Alert from 'react-bootstrap/Alert';
import fetchData from '../../../function/fetchData';
import Items from '../invoiceComponents/Items';
import 'moment/locale/cs';
import { addDays, format } from 'date-fns';
import { Container } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';


const Billing = ({  date, server, token  ,selectedDriverSchedule, setSelectedDriverSchedule, onShow, onHide, drivers, rows, setRows , selectedDriverId, fetchDataFromServer}) => {
    const mondayDate = date ?? moment().startOf('week').format('YYYY-MM-DD')
    let driver = drivers?.filter( one => one.id === selectedDriverId)
    const [loading, setLoading] = useState(false)

    // Posune datum o 14 dní
    const getDateTwoWeeksFromNow = () => {
         // Získání aktuálního data
        const currentDate = new Date();
        
        // Posunutí aktuálního data o 14 dní
        const futureDate = addDays(currentDate, 14);

        // Formátování data do DD.MM.YYYY
        return format(futureDate, 'yyyy-MM-dd');
    }
    
    // form
    const nick =  driver[0]?.nick
    const driverId = selectedDriverId;
    const countOfTrips = selectedDriverSchedule ? selectedDriverSchedule.length : 0;
    const [email, setEmail] = useState("")
    const [dateTillPay, setDateTillPay] = useState(getDateTwoWeeksFromNow())
    const [payedBy, setPayedBy] = useState(null)

    const handleRadioChange = (event) => {
        setPayedBy(event.target.value);
      };
    


    const getDriverData = (id) => {
        if(id){
            const result = drivers.filter( one => one.id === id)
            return result[0]
        }
       
    }
    // Nastavit email
    useEffect(()=> {
        if(driverId){
            const driver = getDriverData(driverId)
            setEmail(driver['email'])
        }
    },[driverId])

    let total = 0;
    let debt = 0;
    let invoicePrice = 0;

    const handleAddRow = (id = null, item = '' , price = 0, schedule = false) => {
        setRows([...rows, {id,  quantity: 1, item: item, price: price , schedule}]);
    };
    // Odebírač klasického itemu
    const handleRemoveRow = (index) => {
        setRows(rows.filter((_, i) => i !== index));
    };

    const handleRemoveOneFromSchedule = (id) => {
        setRows(rows.filter(one => parseInt(one.id) !== parseInt(id)) )
    }

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
           Zakázku odjel řidič: { props.nick}
        </Tooltip>
      );

    const renderTooltipBack = (props) => (
    <Tooltip id="button-tooltip" {...props}>
       Označit zpět za neplacené
    </Tooltip>
    );

    // Získat jméno platícího podle ID
    const getNameWhoPayed = (id) => {
        const result = drivers.filter( one => {
            return parseInt(one.id) === parseInt(id)
        })
        return result ? result[0].nick : ""
    }

    const formated = (date) => {
        return moment(date).format('HH:mm DD.MM.YYYY')
    }

    // Spočítá totální cenu
    if (selectedDriverSchedule) {
        selectedDriverSchedule.forEach(one => {
            total += parseInt(one.price);
            if(!one.payedBy){
                debt += parseInt(one.price);
            }
        });
    }

    // Spočítá totální cenu
    if (rows.length > 0) {
        rows.forEach(one => {
            invoicePrice += parseInt(one.price);
           
        });
    }


    // Změní status u platby zaplceno, neplaceno
    const changePayStatus = (idOfSchedule, payedBy = null) => {
        setSelectedDriverSchedule(selectedDriverSchedule.map(item =>
            parseInt(item.id) === parseInt(idOfSchedule) ? { ...item, payedBy: payedBy } : item
          )) 
          
        fetchData(server + "api2/adminScheduleController.php", {token: token, action: "SET_PAYED" , idOfSchedule: parseInt(idOfSchedule), payedBy: payedBy})
        .then( (res) => {
            if(res.status === "OK"){
                fetchDataFromServer()
            } else {
                alert('chyba spojení, zkuste to později')
            }
            
        } )
    }

    // Odešle data k uložení
    const handleSendData = () => {
      
        const itemsToSend = rows.map(({ id, ...rest }) => rest);
        if(itemsToSend.length > 0 && payedBy && email.length > 5){
            setLoading(true)
            fetchData(server + "api2/adminScheduleController.php", {
                token: token, 
                action: "SAVE_INVOICE",
                items: itemsToSend,
                mondayDate: mondayDate,
                driverId:  driverId,
                email: email,
                dateTillPay: dateTillPay,
                payedBy: payedBy,
    
            }).then((res)=> {
                console.log(res)
                if(res.status !== "OK"){
                    alert('Chyba spojení, zkuste to prosím později.')
                } 
                onHide()
            })
        } else {
            alert('Přidejte alespoň jednu položku k fakturaci, způsob platby a komu budeme fakturu posílat')
        }

    }

    // Přidá jízdu do fakturovaných
    const handleCheckboxChange = (event, id,dateStart, dateEnd, price) => {
        console.log(price)
        if(event){
            handleAddRow(id, 'Jízda: '+ dateStart +" "+ dateEnd , price, true )
        } else {
            handleRemoveOneFromSchedule(id)
        }
        

    };

    return (
        <Modal
            show={onShow}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton style={{ backgroundColor: '#eee' }}>
                <Modal.Title id="contained-modal-title-vcenter" >
                    Vyúčtování šichet, řidič: {nick}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Alert variant="primary">
                <h4>Počet jízd: {countOfTrips}</h4>
                <h4>Celková cena: {total} Kč</h4>
                <h4>Zbývá uhradit: {debt} Kč</h4>
            </Alert>

       
                <h4>Soupis objednaných jízd</h4>
       
                    <Row className='row'>
                        <Col><strong>Jméno</strong></Col>
                        <Col><strong>Start</strong></Col>
                        <Col><strong>Cena</strong></Col>
                        <Col></Col>
                        <Col><strong>KASA</strong></Col>
                    </Row>
                    {
                        selectedDriverSchedule && selectedDriverSchedule.map(one => (
                            <Row key={one.id} className='row'>
                                <Col style={{display: 'flex', gap: 5}}>
                                <Form.Check // prettier-ignore
                                    type={'checkbox'}
                                    onChange={(event)=> handleCheckboxChange( event.target.checked, one.id,formated(one.start), formated(one.end), one.price )}
                                />
                                    {getNameWhoPayed(one.payed_driver_id)}
                                </Col>
                                <Col>{formated(one.start)}</Col>
                                <Col>{one.price} Kč</Col>
                                <Col>
                                    {/* Přehozená zakázka */}
                                    { one.switch_date &&   <OverlayTrigger
                                                                placement="right"
                                                                delay={{ show: 250, hide: 400 }}
                                                                overlay={(props) => renderTooltip({ ...props, nick: one.nick })}
                                                                nick={one.nick}
                                                                >
                                                                 <FontAwesomeIcon icon={faRotate} />
                                                            </OverlayTrigger>
                                    }
                                </Col>
                                
                                <Col>
                                    {/* nezaplaceno */}
                                    { !one?.payedBy && <div style={{display: 'flex', alignItems: 'center' , gap: 10}}>
                                                            <p style={{cursor: 'pointer', color: 'blue'}} onClick={()=> changePayStatus(one.id,'bank')}>Převod</p>
                                                            <p style={{cursor: 'pointer' ,color: 'green'}} onClick={()=> changePayStatus(one.id,'cache')}>Hotově</p>
                                                        </div>
                                    }

                                    {/* Zaplaceno - způsob cache */}
                                    { one?.payedBy === 'cache' && <div style={{display: 'flex', alignItems: 'center' , gap: 10, background: '#3cc4d5', borderRadius:10, paddingLeft:10, marginBottom: 2}}>
                                                                    Placeno
                                                                    <FontAwesomeIcon icon={faMoneyBill}/>
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        delay={{ show: 250, hide: 400 }}
                                                                        overlay={(props) => renderTooltipBack({ ...props, nick: one.nick })}
                                                                    >
                                                                        <FontAwesomeIcon icon={faBackward} onClick={()=> changePayStatus(one.id)} color={'grey'}/>
                                                                    </OverlayTrigger>
                                                                 </div>
                                    }
                                     {/* Zaplaceno - způsob bank */}
                                     { one?.payedBy === 'bank' && <div style={{display: 'flex', alignItems: 'center' , gap: 10, background: '#3cc4d5', borderRadius:10, paddingLeft:10, marginBottom: 2}}>
                                                                    Placeno
                                                                    <FontAwesomeIcon icon={faBuildingColumns} />
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        delay={{ show: 250, hide: 400 }}
                                                                        overlay={(props) => renderTooltipBack({ ...props, nick: getNameWhoPayed(one.payed_driver_id, null) })}
                                                                        >
                                                                        <FontAwesomeIcon icon={faBackward} onClick={()=> changePayStatus(one.id, null)} color={'grey'}/>
                                                                    </OverlayTrigger>
                                                                    
                                                                    
                                                                 </div>
                                    }
                                </Col>
                                 
                            </Row>
   
                        ))
                    }
           
            {/* Položky faktury */}
  
            

            <br></br>
            <Items rows={rows} setRows={setRows} handleAddRow={handleAddRow} handleRemoveRow={handleRemoveRow}/>
            <br></br>
            <h3 style={{color: 'rgb(5, 44, 101)'}}>Celkem na faktuře: {invoicePrice} Kč</h3>
            <div>
            <Container style={{ gap: 10 }}>
                <Form.Check
                type={'radio'}
                name="payment"
                value="cache"
                checked={payedBy === 'cache'}
                onChange={handleRadioChange}
                />
                <label>Faktura hotově(zaplaceno)</label>
            </Container>
            <Container style={{ gap: 10 }}>
                <Form.Check
                type={'radio'}
                name="payment"
                value="card"
                checked={payedBy === 'card'}
                onChange={handleRadioChange}
                />
                <label>Převodem</label>
            </Container>
            
            </div>
               
        
            </Modal.Body>
            <Modal.Footer>
                <div>
                    Na email:
                    <input value={email} onChange={(e)=> setEmail(e.target.value)} style={{border: 'none', width: 200, marginLeft: 10,borderBottom: '1px solid grey' }}/>
                    Splatnost: <input type='date' style={{border: 'none', marginLeft: 10,borderBottom: '1px solid grey' }} value={dateTillPay} onChange={(e)=>setDateTillPay(e.target.value)}/>
                </div>
                <div style={{flex: 1}}></div>
                {!loading &&
                    <Button variant="success" onClick={handleSendData}>  
                        Odeslat fakturu
                    </Button>
                }
                {loading &&
                <Button variant="success" disabled>  
                    <Spinner animation="border" role="status" size="sm">
                    </Spinner>
                    Ukládám
                </Button>
                }
                <Button onClick={onHide}>Zavřít</Button>
        
            </Modal.Footer>
        </Modal>
    );
}

export default Billing;
